module.exports = __webpack_public_path__ + "img/home10.a95757b2.jpg";